import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import { SearchingStateTabs } from '../types';
import { useTranslation } from 'react-i18next';

export const Tabs = ({
  currentSearching,
  setCurrentSearching
}: {
  currentSearching: SearchingStateTabs;
  setCurrentSearching: Dispatch<SetStateAction<SearchingStateTabs>>;
}) => {
  const { t } = useTranslation();
  const handleSearchingGames = () => {
    setCurrentSearching('games');
  };

  const handleSearchingProviders = () => {
    setCurrentSearching('providers');
  };

  const TABS = [
    { label: 'general.games', key: 'games', onClick: handleSearchingGames },
    { label: 'general.providers', key: 'providers', onClick: handleSearchingProviders }
  ];

  return (
    <div className="flex bg-sm_tabs_bg rounded-[20px] mb-4 overflow-x-auto mx-1">
      {TABS.map((tab) => {
        return (
          <div
            onClick={() => tab.onClick()}
            key={tab.key}
            className={classNames(
              'w-1/2 px-5 py-3 font-bold flex flex-row justify-center text-center text-sm whitespace-nowrap flex-1 cursor-pointer rounded-[20px]',
              {
                'active-tab text-sm_tabs_text_active': currentSearching === tab.key,
                'text-sm_tads_text': currentSearching !== tab.key
              }
            )}>
            <p className="capitalize">{t(tab.label)}</p>
          </div>
        );
      })}
    </div>
  );
};
